import React from "react";
// import SiteExplanation from './SiteExplanation/SiteExplanation';
import MetaTags from "../MetaTags/MetaTags";
import VideoComponent from "./VideoComponent/VideoComponent";
//import ModernSection from "./ModernSection/ModernSection";
import ModernSection from "./ModernSection/ModernSection_1";
import Stats from "./Stats/Stats";
import GoToTopButton from "../PurpleButton/GoToTopButton";
// import MagneticDots from "./MagneticDots/MagneticDots";

const HomePage = () => {
  return (
    <section
      style={{
        backgroundColor: "black",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <MetaTags
        title="פינתי"
        description="זהו דף הבית של האתר, המציג את התוכן המרכזי."
        url="/"
      />

      <VideoComponent />

      {/*  <SiteExplanation /> */}

      <Stats
        numberVlogs={53}
        numberQuestions={28}
        numberTopics={3}
        numberArchitecture={2}
      />

      <ModernSection
        title="פתרונות LeetCode"
        quote="בדיוק כמו בחיים, גם בתכנות יש יותר מדרך אחת להגיע לפתרון."
        paragraph="כאן מחכה לכם אוסף ייחודי של וולוגים שמעמיקים בעולם פתרון השאלות הפופולריות מ-LeetCode. בכל וולוג נתמקד בשאלה, נבין את הדרישות והאילוצים, נסקור גישות לפתרון, ונלמד על סיבוכיות זמן וזיכרון. הוולוגים יעזרו לכם לחדד חשיבה אלגוריתמית, לשפר כישורי תכנות ולהתכונן לראיונות עבודה בשלבים שונים בקריירה."
      />

      {/*
      <ModernSection
        title="נושאים טכנולוגיים"
        quote="בעולם הטכנולוגיה, כל שאלה היא התחלה של פתרון וכל פתרון הוא התחלה של אתגר חדש."
        paragraph="כאן תמצאו אוסף עשיר של וולוגים שמסבירים באופן מעמיק את כל מה שקשור בנושאים טכנולוגיים שונים. המאגר נבנה במיוחד כדי לעזור לכם להבין את העקרונות, המושגים והטכנולוגיות שמאחורי כל נושא, ולהעמיק את הידע שלכם בתחום. כל וולוג מציע הסברים ברורים, דוגמאות פרקטיות, ונותן כלים חשובים להתמודד עם בעיות טכנולוגיות בצורה טובה יותר. המטרה היא לא רק להעשיר את הידע שלכם, אלא גם להפוך אתכם למומחים בתחומים השונים ולהתמודד עם אתגרים טכנולוגיים בצורה יעילה ומתקדמת."
      />
      */}

      <ModernSection
        title="וולוגים שמתמקדים בעולם התכנות"
        quote="לא משנה כמה זמן נעשה את זה, תמיד יש עוד משהו חדש ללמוד בתכנות."
        paragraph="כאן תמצאו תכנים מעמיקים וממוקדים שנועדו לשפר את ההבנה שלכם בנושאים טכניים מעולם התכנות. הוולוגים מציעים תובנות ברורות וטיפים שימושיים להתמודדות עם אתגרי פיתוח ולהעמקת הידע. כל וולוג מעביר ידע מעשי, עם דגש על נושאים שנוגעים לעבודה היומיומית של מתכנתים – למתחילים ולמנוסים כאחד."
      />

      <ModernSection
        title="ארכיטקטורת קוד"
        quote="ארכיטקטורה טובה היא כמו מוזיקה - היא נראית פשוטה, אבל מאחוריה עומדת תכנון מורכב."
        paragraph="כאן תמצאו אוסף של וולוגים המתמקדים בארכיטקטורת קוד, עקרונות תכנון ודפוסי עיצוב. המאגר עוזר להבין איך לתכנן מערכות תוכנה בצורה נכונה, עם דגש על עקרונות כמו SOLID, DRY ו-KISS. כל וולוג כולל דוגמאות מעשיות, הסברים ברורים וטיפים לכתיבת קוד נקי, תחזוקתי וסקיילבילי – שיישאר טוב גם בטווח הארוך."
      />

      <GoToTopButton />
    </section>
  );
};

export default HomePage;
